import React, { Component } from 'react';
import GetOnlyviewUbication from './getOnlyviewUbication';
//import GetViewUbication from '../Componen/getViewUbication';

import '../css_generales/getNuevaOrden.css';
import 'whatwg-fetch';

class getNuevaOrden extends Component {
  constructor(){
    super();
    this.state = {
        forma_pago :"",
        razon_social :"CONSUMIDOR FINAL",
        ruc:"9999999999999",
        telefono:"S/N",
        direccion:"S/N",
        email:"S/N",
        alias:"",
        total_precio:0,
        costo_delivery:0,
        total_final:0,
        lista_items:[],
        fecha_creacion:'',
        cod_pedido:'',
        lon:0,
        lat:0,
        direccion_entrega:'',
        referencia_entrega:'',
        valor_efectivo:0,
        id_motorizado:0,
        nombre_motorizado:''
    }
  }

  getDetalleComboPrecio=(adicionales_json)=>{
    //return null
    if(adicionales_json){
      //  console.log("S"+adicionales_json)
      //  //

      let adicional_array = JSON.parse(adicionales_json)
//console.log("SA"+adicionales_json)
//return null
      console.log(adicional_array)
    
      let precio_adicional = 0
      adicional_array.forEach(cp_detalle => {
          if(cp_detalle.complemento==='Combo'){
            cp_detalle.CDetalle.forEach(cp_detalle_combo => {
               precio_adicional = precio_adicional + Number(cp_detalle_combo.precio)
            })
          }else{
            if(cp_detalle.complemento==='Adicional'){
              let descuento_var =0
              if (cp_detalle.descuento) {
                //descuento_var = Number(cp_detalle.descuento)
              }
              //console.log("--->"+cp_detalle.descuento)
              precio_adicional = precio_adicional + ((Number(cp_detalle.precio) - descuento_var).toFixed(2)*Number(cp_detalle.cant))
            //  precio_adicional = precio_adicional + (Number(cp_detalle.precio)*Number(cp_detalle.cant))
            }else{
              //descripcion = descripcion +  cp_detalle.producto
            }
          }
      })
       return precio_adicional
    }else{
      return 0
    }
  }

  getDetalleCombo=(descripcion_ad,adicionales_json,adicionales)=>{
    //return null
    let descripcion = descripcion_ad
    /*if(adicionales){
      adicionales.forEach(cp_detalle => {
        descripcion = descripcion  + cp_detalle.cantidad + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio_neto + '$'
      })

    }*/
    if(adicionales_json){
      let adicional_array = JSON.parse(adicionales_json)
      
      adicional_array.forEach(cp_detalle => {
          if(cp_detalle.complemento==='Combo'){
            cp_detalle.CDetalle.forEach(cp_detalle_combo => {
               if(descripcion!=='') descripcion = descripcion + ' + '
               descripcion = descripcion + cp_detalle_combo.cant + 'x '+ cp_detalle_combo.producto
            })
          }else{
            if(descripcion!=='') descripcion = descripcion + ' + '
            if(cp_detalle.complemento==='Adicional'){
              if(Number(cp_detalle.descuento)>0){
                descripcion = descripcion  + cp_detalle.cant + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio + '$'+ " -("+ cp_detalle.descuento + "$)"
              }else{
                descripcion = descripcion  + cp_detalle.cant + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio + '$'
              }
                }else{
              descripcion = descripcion +  cp_detalle.producto
            }
          }
      })
      return(
        <React.Fragment>
          {descripcion}
        </React.Fragment>
      )
    }else{
      return(
        <React.Fragment>
          {descripcion}
        </React.Fragment>
      )
    }
  }
  get_go_to_sub=()=>{

  }
  get_Detalle_Pedido =()=>{
    //{this.mostrarItems()}
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_60x60
    const token_image = url_image+file_xxx+separator
    const ext="_60x60.png?alt=media"
    const lista_items = this.state.lista_items
     //console.log(this.props.id_tipo_permiso)
    return (
      <React.Fragment>
        <div className="grid-container_getpedido" style={{"backgroundColor":"#04c46c","color":"white"}} >
          <div className="lbl_title_final_getpedido" > DATOS DEL PEDIDO</div>
          <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4609047631582004492-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">Fecha del Pedido: {this.state.fecha_creacion}</div>
        </div> 
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4609047631582004492-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">Código de Pedido: {this.state.cod_pedido}
          {"         "} - <span style={{"fontSize":"18pt"}}>Motorizado: {this.state.nombre_motorizado}</span>
          </div>
        </div>

        <div className="grid-container_getpedido">
          <div className="lbl_title_final_getpedido">PRODUCTOS</div>
          <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
        </div>
        <React.Fragment> 
          {lista_items.map((item , index) => (
             <div className="grid-container-detalle_pedido" key={index}>
               <div className="lbl_cantidad-detalle_pedido">{item.cantidad+"x"}</div>
               <div className="lbl_precio-detalle_pedido">${Number(Number(item.precio_neto)+this.getDetalleComboPrecio(item.adicionales_json)).toFixed(2)}</div>
               <div className="lbl_item-detalle_pedido">{item.producto} <span style={{"color":"red"}}> {item.observacion}</span></div>
               <div className="lbl_descripcion-detalle_pedido">
                {this.getDetalleCombo(item.descripcion,item.adicionales_json,item.adicionales)}
               </div>
               <div className="lbl-imagen-detalle_pedido">
                 <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
                  src={
                  ((item.uuid_imagen+'').trim()==='')?
                    "https://www.grupomn.net/app/img/sinfoto.png"
                  :
                    token_image+item.uuid_imagen+ext
                  }/>
               </div>
             </div>
          ))}
        </React.Fragment>
        <div className="grid-container_getpedido">
          <div className="lbl_title_final_getpedido">DIRECCIÓN DE ENTREGA</div>
          <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
        </div>
        <div className="grid-container_getpedido">
          <div className="lbl_title_final_getpedido">{this.state.direccion_entrega}</div>
          <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
        </div>
        <div className="grid-container_getpedido">
          <div className="lbl_title_final_getpedido">{this.state.referencia_entrega}</div>
          <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
        </div>
        {(Number(this.state.lat)!==0)?
          <div className="grid-container_buy_getviewpedido_ubicacion">
            <div className="lbl_icon_final_buy_getviewpedido_ubicacion">
              <div className="cssversion_pw100 cssversion_ph15 cssversion_contentCenter">
                <div>
                  <center>
                    <a href={`https://waze.com/ul?ll=${this.state.lat},${this.state.lon}&navigate=yes`} target="_blank"> Abrir en Waze </a><br/>
                    <a href={`https://www.google.com/maps/place/${this.state.lat},${this.state.lon}`} target="_blank"> Abrir en Google Maps </a>
                  </center>
                </div>
              </div>
              <div className="cssversion_pw100 cssversion_ph85">
              {(Number(this.state.lon)>0||Number(this.state.lon)<0)?
                <React.Fragment>
                {(Number(this.props.id_tipo_permiso)!==3)?
                  <GetOnlyviewUbication className="pruebas" lat={this.state.lat} edit={false} zoom={14}  lon={this.state.lon}/>
                  :
                  <GetOnlyviewUbication className="pruebas" lat={this.state.lat} edit={false} zoom={14}  lon={this.state.lon}/>
                }
                </React.Fragment>
              :''}
              </div>
            </div>
          </div>
        :null}
        <div className="grid-container_getpedido">
          <div className="lbl_title_final_getpedido">FORMA DE PAGO</div>
          <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4609047631582004492-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">
          {this.state.forma_pago}
          {(Number(this.state.valor_efectivo)>0)?
          <div className="cssversion_pxh50 cssversion_pxw70 cssversion_contentCenter" style={{"display":"flex"}}>
            <div className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#82E0AA","borderRadius": "15px"}}>
              <span className="span-global" style={{"color":"white"}}>{this.state.valor_efectivo}$</span>
            </div>
          </div>:''
        }
          </div>
        </div>
        <div className="grid-container_getpedido">
          <div className="lbl_title_final_getpedido">DATOS DEL COMPROBANTE</div>
          <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4798580041582004495-128.png') }  /></div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4609047631582004492-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">{this.state.alias}</div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">{this.state.razon_social}</div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">{this.state.ruc}</div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9180212681582004495-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">{this.state.telefono}</div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">{this.state.direccion}</div>
        </div>
        <div className="grid-container_buy_getpedido">
          <div className="lbl_title_final_buy_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') }  /></div>
          <div className="lbl_icon_final_buy_getpedido">{this.state.email}</div>
        </div>
        <div className="grid-container-menu_list-datos_pedidos_totales">
          <div className="div_menu_1_list-datos_pedidos_totales">Subtotal Productos</div>
          <div className="lbl_menu_2_list-datos_pedidos_totales">${    (Number(this.state.total_final) -Number(this.state.costo_delivery))  .toFixed(2)}</div>
        </div>
        <div className="grid-container-menu_list-datos_pedidos_totales">
          <div className="div_menu_1_list-datos_pedidos_totales">Transporte</div>
          <div className="lbl_menu_2_list-datos_pedidos_totales">${Number(this.state.costo_delivery).toFixed(2)}</div>
        </div>
        <div className="grid-container-menu_list-datos_pedidos_totales">
          <div className="div_menu_1_list-datos_pedidos_totales">Total Comprobante</div>
          <div className="lbl_menu_2_list-datos_pedidos_totales">${Number(this.state.total_final).toFixed(2)}</div>
        </div>
      </React.Fragment>
    )
  }
  /*{(Number(this.state.lon)>0||Number(this.state.lon)<0)?
    <GetOnlyviewUbication className="pruebas" lat={this.state.lat}  lon={this.state.lon}/>
  :''}*/

  get_Pedido =()=>{
    const url= this.props.dir_url + "webapp/getDatosDetallePedido";
    const token =  this.props.token
    const token_Pedido =  this.props.token_pedido
    var obj = { accion:'datosdetallepedido', token, token_Pedido};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //cod_pedido, fecha_creacion, total, delivery, lat, lon, cantidad, precio_neto, producto, descripcion,
      // razon_social, ruc, telefono, direccion, correo_electronico, alias, forma_pago
      if(data[0].status==="ok"){
        this.setState({
          lon:data[0].msg[0].lon,
          lat:data[0].msg[0].lat,
          forma_pago:data[0].msg[0].forma_pago,
          razon_social:data[0].msg[0].razon_social,
          ruc:data[0].msg[0].ruc,
          telefono:data[0].msg[0].telefono,
          direccion:data[0].msg[0].direccion,
          email:data[0].msg[0].correo_electronico,
          alias:data[0].msg[0].alias,
          total_final:data[0].msg[0].total,
          costo_delivery:data[0].msg[0].delivery,
          fecha_creacion:data[0].msg[0].fecha_creacion,
          cod_pedido:data[0].msg[0].cod_pedido,
          lista_items:data[0].msg,
          direccion_entrega:data[0].msg[0].direccion_entrega,
          referencia_entrega:data[0].msg[0].referencia_entrega,
          valor_efectivo:Number(data[0].msg[0].valor_efectivo),
          id_motorizado:Number(data[0].msg[0].id_motorizado),
          nombre_motorizado:data[0].msg[0].nombre_motorizado
        })
      }
    })
    .catch(console.log)
  }
  render() {

    return (
      <div className="modal-dialog-datos_pedidos">
        <div className="modal-content-datos_pedidos">
          <div className="grid-container-menu_list-datos_pedidos">
            <div className="div_menu_1_list-datos_pedidos">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_aceptar_pedido( this.props.token_pedido)} />
            </div>
            <div className="lbl_menu_2_list-datos_pedidos">
              <span className="span-global-link">Nuevo Pedido</span>
            </div>
          </div>
          <div style={{"height": "90%","overflowY": "auto"}}>
            <div>
            {this.get_Detalle_Pedido()}
            </div>
          </div>
        </div>
      </div>
    );
  }
  componentDidMount (){
    this.get_Pedido()
  }
}
export default getNuevaOrden;
